var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUniversityKm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9132 7.25287C16.0378 8.12513 16.0378 9.05969 15.8509 9.99426C15.0409 14.044 11.0534 16.6608 7.00365 15.8509C2.95388 15.0409 0.337101 11.0534 1.14706 7.00365C1.95701 2.95388 6.00678 0.337101 10.0566 1.14706",
    fill: "#F2FDFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9132 7.25287C16.0378 8.12513 16.0378 9.05969 15.8509 9.99426C15.0409 14.044 11.0534 16.6608 7.00365 15.8509C2.95388 15.0409 0.337101 11.0534 1.14706 7.00365C1.95701 2.95388 6.00678 0.337101 10.0566 1.14706",
    stroke: "#12CC92",
    strokeWidth: 1.43705,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.06249 10.9902C8.92273 10.9902 9.62009 10.2928 9.62009 9.43261C9.62009 8.57236 8.92273 7.875 8.06249 7.875C7.20225 7.875 6.50488 8.57236 6.50488 9.43261C6.50488 10.2928 7.20225 10.9902 8.06249 10.9902Z",
    fill: "#E6EDF9",
    stroke: "#12CC92",
    strokeWidth: 1.43705,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4209 5.38474C14.2811 5.38474 14.9785 4.68738 14.9785 3.82714C14.9785 2.96689 14.2811 2.26953 13.4209 2.26953C12.5606 2.26953 11.8633 2.96689 11.8633 3.82714C11.8633 4.68738 12.5606 5.38474 13.4209 5.38474Z",
    fill: "#E6EDF9",
    stroke: "#12CC92",
    strokeWidth: 1.43705,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.24707 8.18552L12.4246 5.07031",
    stroke: "#12CC92",
    strokeWidth: 1.43705,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniversityKm);
export default __webpack_public_path__ + "static/media/university_km.e6a914769c096febfee661a904b2d1a6.svg";
export { ForwardRef as ReactComponent };